import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { loginRequest, graphConfig } from "../authConfig";
import axios from "axios";
import Cookies from "js-cookie";
import { ComponenteSpinner } from "../pages/adminComponents/ComponenteSpinner";

const LOGIN_LOCK = "entra_login_in_progress";
const LOGIN_DONE = "entra_login_done";

const ProtectedRouteEntraID = ({ setIsLogin }) => {
    const { instance, accounts } = useMsal();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const isInIframe = window.self !== window.top;
    const isCambioContraseniaConToken = location.pathname === "/cambiarcontrasenia" && location.search.includes("token=");

    const [isFlutter, setIsFlutter] = useState(false);
    const [popupBlocked, setPopupBlocked] = useState(false);

    useEffect(() => {
        const handler = (event) => {
            if (
                event.data?.source === "miespol" &&
                event.data?.accessToken
            ) {
                sessionStorage.setItem("access_token", event.data.accessToken);
                setIsFlutter(true);
                setIsAuthenticated(true);
                setIsLogin(true);
                setLoading(false);
            }
        };

        window.addEventListener("message", handler);
        return () => window.removeEventListener("message", handler);
    }, []);

    useEffect(() => {
        if (isCambioContraseniaConToken) {
            setIsAuthenticated(true);
            setLoading(false);
            return;
        }
         // 🔵 NUEVO: Flutter manda el token → NO MSAL
        if (isFlutter) {
            setIsAuthenticated(true);
            setLoading(false);
            return;
        }

        const authenticate = async () => {
            try {
                /* ===============================
                   1️⃣ Procesar redirect (solo app normal)
                =============================== */
                const hasRedirect =
                    window.location.hash.includes("code=") ||
                    window.location.hash.includes("state=");

                if (hasRedirect && !isInIframe && !sessionStorage.getItem(LOGIN_DONE)) {
                    sessionStorage.setItem(LOGIN_DONE, "1");
                    await instance.handleRedirectPromise();

                    //  Inicio cambio para cerrar el loginpopup una vez validada la sesión
                    if (window.opener) {
                        window.close();
                        return;
                    }
                    // 🔴🔴🔴 FIN DEL CAMBIO 🔴🔴🔴


                    window.history.replaceState(
                        {},
                        document.title,
                        window.location.pathname + location.search
                    );
                }

                /* ===============================
                   2️⃣ Si NO hay cuenta → login
                =============================== */
                if (accounts.length === 0) {
                    setIsAuthenticated(false);
                    setLoading(false);
                    return;
                }

                /* ===============================
                   3️⃣ Obtener access_token
                =============================== */
                let response;
                try {
                    response = await instance.acquireTokenSilent({
                        ...loginRequest,
                        account: accounts[0],
                    });
                } catch {
                    if (isInIframe) {
                        response = await instance.acquireTokenPopup(loginRequest);
                    } else {
                        instance.acquireTokenRedirect(loginRequest);
                        return;
                    }
                }

                sessionStorage.setItem("access_token", response.accessToken);
                /* 🟢 NUEVO: Cierre manual del Popup y envío de token */
                // Si esta ventana fue abierta por otra (es un popup) y no es el iframe principal
                if (window.opener && !isInIframe) {
                    console.log("📨 Enviando token a la ventana padre y cerrando...");
                    
                    // 1. Enviamos el token a la ventana que nos abrió (el iframe esperando)
                    window.opener.postMessage({
                        source: "miespol",
                        accessToken: response.accessToken
                    }, "*");

                    // 2. Cerramos esta ventana emergente inmediatamente
                    window.close();
                    return; // Detenemos la ejecución aquí
                }
                /* 🔴 FIN DE LO NUEVO */
                /* ===============================
                   4️⃣ Validar token contra Graph
                =============================== */
                const graphResp = await fetch(graphConfig.graphMeEndpoint, {
                    headers: { Authorization: `Bearer ${response.accessToken}` },
                });

                if (!graphResp.ok) throw new Error("Token inválido");

                /* ===============================
                   5️⃣ Token backend (solo app normal)
                =============================== */
                if (!isInIframe) {
                    const apiResp = await axios.get(
                        `${process.env.REACT_APP_API}api/CuentaUsuario/singuardar/30`,
                        {
                            headers: {
                                Authorization: `Bearer ${response.accessToken}`,
                            },
                        }
                    );

                    Cookies.set("token", apiResp.data.token, { expires: 1 });
                }

                setIsLogin(true);
                setIsAuthenticated(true);

                /* ===============================
                   6️⃣ Avisar que el token está listo
                =============================== */
                window.dispatchEvent(
                    new CustomEvent("entra-token-ready", {
                        detail: { source: "ProtectedRouteEntraID" },
                    })
                );
            } catch (err) {
                console.error("❌ Error autenticando:", err);
                setIsAuthenticated(false);
            } finally {
                setLoading(false);
                sessionStorage.removeItem(LOGIN_DONE);
            }
        };

        authenticate();
    }, [accounts, instance, location.search,isFlutter]);

    /* 🟢 NUEVO: useEffect exclusivo para intentar Login en Iframe */
    useEffect(() => {
        // Solo intentamos si: cargó todo, no estamos autenticados, es iframe, no es flutter y no está bloqueado
        if (!loading && !isAuthenticated && isInIframe && !isFlutter && !popupBlocked) {
            
            // Evitamos que se ejecute dos veces
            if (sessionStorage.getItem(LOGIN_LOCK)) return;
            sessionStorage.setItem(LOGIN_LOCK, "1");

            instance.loginPopup(loginRequest)
                .then(() => {
                    // Si funciona, genial
                    setIsAuthenticated(true);
                })
                .catch((error) => {
                    console.error("❌ Popup bloqueado o cerrado:", error);
                    // Si el error es por bloqueo, activamos la bandera
                    if (error.errorCode === "popup_window_error" || error.name === "BrowserAuthError") {
                        setPopupBlocked(true);
                    }
                })
                .finally(() => {
                    sessionStorage.removeItem(LOGIN_LOCK);
                });
        }
    }, [loading, isAuthenticated, isInIframe, isFlutter, popupBlocked, instance]);

    /* 🔓 EXCEPCIÓN FINAL */
    if (isCambioContraseniaConToken) {
        return <Outlet />;
    }

    /* ===============================
       7️⃣ Spinner global
    =============================== */
    if (loading) {
        return <ComponenteSpinner />;
    }
    if (isFlutter && sessionStorage.getItem("access_token")) {
        return <Outlet />;
    }
    /* ===============================
    8️⃣ Login explícito si no autenticado
=============================== */
if (!isAuthenticated) {
    if (isInIframe) {
        if (isFlutter) {
            return <ComponenteSpinner />;
        }

        // 🟢 CASO A: El navegador bloqueó el popup automático. 
        // Mostramos botón manual (esto SIEMPRE funciona).
        if (popupBlocked) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', padding: '20px', textAlign: 'center', backgroundColor: '#f8d7da', color: '#721c24' }}>
                    <h3>⚠️ Inicio de sesión requerido</h3>
                    <p>Tu navegador bloqueó la ventana de inicio de sesión automática.</p>
                    <button 
                        onClick={() => {
                            // Al ser un click manual, el navegador NO lo bloquea
                            instance.loginPopup(loginRequest)
                                .then(() => window.location.reload())
                                .catch(e => console.error(e));
                        }} 
                        style={{ padding: '10px 20px', marginTop: '15px', cursor: 'pointer', fontWeight: 'bold', backgroundColor: '#0078d4', color: 'white', border: 'none', borderRadius: '4px' }}
                    >
                        Iniciar Sesión Manualmente
                    </button>
                </div>
            );
        }

        // 🟢 CASO B: Aún estamos intentando abrirlo automáticamente (muestra spinner/mensaje)
        return (
            <div style={{ textAlign: "center", marginTop: "50px" }}>
                <ComponenteSpinner />
                <p>Intentando abrir ventana de autenticación...</p>
            </div>
        );
    }

    // Si NO es iframe (App normal), redirigimos
    instance.loginRedirect({
        ...loginRequest,
        redirectUri: window.location.href,
    });
    return null;
}

    /* ===============================
       9️⃣ Regla FINAL de acceso
          - iframe → access_token
          - app normal → cookie
    =============================== */
    const hasAccessToken = !!sessionStorage.getItem("access_token");
    const hasApiToken = !!Cookies.get("token");

    if (!hasAccessToken || (!isInIframe && !hasApiToken)) {
        return <ComponenteSpinner />;
    }

    /* ===============================
       🔓 Ruta liberada
    =============================== */
    return <Outlet />;
};

export default ProtectedRouteEntraID;